import { DistrictModel } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { translateItem } from '@source/utilities/hooks';

import { Filters } from './construct-filters';

export const setDistrictsFilters = async (districts: DistrictModel[], filters: Filters) => {
    const { districtId } = window.__ENVIRONMENT_DETAILS__;
    const hasDistricts = districts.length > 1;

    if (hasDistricts) {
        // If a districtId is set in __ENVIRONMENT_DETAILS__, it means that the housing overview of a district is opened.
        // Limit the district filters in that case
        districts = districtId ? districts.filter(({ id }) => id === districtId) : districts;

        const filterName = FILTER_NAMES.districts;

        filters[filterName] = {
            expanded: false,
            icon: 'icons-pin-outline',
            title: await translateItem('Filters.District.label'),
            dropdownLabel: await translateItem('Filters.District.dropdownLabel'),
            filterFunctions: {
                constructionNumber: (constructionNumber, filterInput) =>
                    constructionNumber.districtId === filterInput.value,
                propertyType: (propertyType, filterInput) =>
                    propertyType.districtId === filterInput.value,
                projectPhase: (projectPhase, filterInput) =>
                    projectPhase.districtId === filterInput.value,
            },
            filterName,
            hasRangeValues: false,
            filters: {
                type: 'checkbox',
                components: districts.map((district) => ({
                    id: `${filterName}-${district.name}`,
                    label: `${district.name}`,
                    value: `${district.id}`,
                    name: filterName,
                    checked: hasFilterUrl(`${district.id}`, filterName),
                    type: 'checkbox',
                })),
            },
        };
    }
};
